export function newClientResponseId() {
  if (typeof window !== "undefined" && window.crypto?.randomUUID) return window.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const value = Math.floor(Math.random() * 16);
    return (char === "x" ? value : (value & 3) | 8).toString(16);
  });
}

export function commonErrorMessage(error) {
  if (error?.status === 409) return "The saved study state changed. We’ll check it before continuing.";
  if (error?.status === 403) return "This comparison expired. We’ll safely reload it before continuing.";
  return "We could not confirm that response was saved. Please retry the same response.";
}
